import React from 'react';
import Select, { components } from 'react-select';
import { selectStyles, selectTheme } from './SelectStyles';
import { SelectOption } from './SingleSelect';
import './select-portal-styles.css';
import CustomTooltip from '../CustomTooltip';

interface MultiSelectProps {
  name: string;
  options: SelectOption[];
  placeholder: string;
  onChange: (selectedOptions: any) => void;
  className?: string;
  width?: string;
  value?: any;
  components?: any;
  isClearable?: boolean;
  optionTooltip?: (option: any) => string | null;
}

const CustomOption = (props: any) => {
  const { data, children, selectProps, innerRef, innerProps } = props;

  const tooltipContent = selectProps.optionTooltip ? selectProps.optionTooltip(data) : null;

  const optionInnerContent = (
    <div className={`
      flex items-center justify-between
      ${data.isDisabled ? 'text-gray-700 dark:text-gray-400' : ''}
    `}>
      <span>{children}</span>
      {data.isImported && (
        <span className="ml-2 text-xs text-gray-700 dark:text-gray-400">
          (Imported)
        </span>
      )}
    </div>
  );

  if (tooltipContent && data.isDisabled) {
    return (
      <components.Option
        {...props}
        className={`${data.isDisabled ? 'opacity-70 !cursor-not-allowed' : ''}`}
        innerProps={innerProps}
      >
        <CustomTooltip 
          title={tooltipContent} 
          placement="top"
        >
          {optionInnerContent}
        </CustomTooltip>
      </components.Option>
    );
  }

  return (
    <components.Option
      {...props}
      className={`${data.isDisabled ? 'opacity-70 !cursor-not-allowed' : ''}`}
      innerProps={innerProps}
    >
      {optionInnerContent}
    </components.Option>
  );
};

const MultiSelect: React.FC<MultiSelectProps> = ({
  name,
  options,
  placeholder,
  isClearable = true,
  onChange,
  value,
  className = "text-sm",
  width = "w-80",
  components: customComponents,
  optionTooltip
}) => {
  const mergedComponents = {
    Option: CustomOption,
    ...customComponents
  };



  return (
    <div className={`relative ${width} select-container 
      [--select-bg:white] 
      dark:[--select-bg:rgb(31,41,55)] 
      [--select-text:rgb(17,24,39)] 
      dark:[--select-text:rgb(243,244,246)] 
      [--select-border:rgb(156,163,175)] 
      dark:[--select-border:rgb(75,85,99)] 
      [--select-hover:rgb(243,244,246)] 
      dark:[--select-hover:rgb(55,65,81)] 
      [--select-active:rgb(219,234,254)] 
      dark:[--select-active:rgb(55,65,81)] 
      [--select-multi-bg:rgb(219,234,254)] 
      dark:[--select-multi-bg:rgb(55,65,81)] 
      [--select-multi-text:rgb(30,58,138)] 
      dark:[--select-multi-text:rgb(243,244,246)] 
      [--select-placeholder:rgb(107,114,128)] 
      dark:[--select-placeholder:rgb(156,163,175)]`}>
      <Select
        isMulti
        name={name}
        options={options}
        className={`${className} select-component`}
        classNamePrefix="select"
        placeholder={placeholder}
        onChange={onChange}
        styles={selectStyles}
        theme={selectTheme}
        isClearable={isClearable}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        value={value}
        components={mergedComponents}
        isOptionDisabled={(option) => option.isDisabled}
        //@ts-ignore
        optionTooltip={optionTooltip}
      />
    </div>
  );
};

export default MultiSelect; 